<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-progress-circular v-if="error.length == 0" indeterminate color="primary"/>
      <v-alert :value="error.length > 0" type="error" data-testid="v-alert_0dc61723-15db-4624-8e7e-5989bb0b900d">
        {{error}}
      </v-alert>
      <iframe v-if="tokenLoginCSRFLink != null && tokenLoginCSRFLink != ''" v-bind:src="tokenLoginCSRFLink"></iframe>
    </v-layout>
  </v-container>
</template>

<script>
import TenancyLoginForm from '@/components/login/TenancyLoginForm';
import { sharedReactorAuthentication as authHandler} from 'reactor-js-core/dist/authentication.js'
import { dashboardUserService } from 'reactor-js-core/dist/services/dashboarduserservice.js'
import { dashboardUserSessionService } from 'reactor-js-core/dist/services/dashboardusersessionservice.js'
import utils from 'reactor-js-core/dist/utils.js'
import { persistentStorage } from 'reactor-js-core/dist/persistentstorage.js'

var configs = require('../../../config');
const env = process.env.NODE_ENV;
const config = env === 'development' ? configs.dev : configs.build;

export default {
  name: 'TokenLogin',
  extends: TenancyLoginForm,
  props: {
  },
  data () {
    return {
      tokenLoginCSRFLink: '',
      error: ''
    }
  },
  methods: {
    validRedirect: function(candidate) {
      return this.$root.mayRedirectTo(candidate);
    },
    isAuthenticated() {
      return false;
    },
    tokenLoginFailure(response) {
      if (response.exceptionName === "UserInactiveException") {
        this.error = this.$t('login_user_inactive');
      }
      else {
        this.error = this.$t('login_failed');
      }
    }
  },
  mounted() {
    if (this.$route.query.login_csrf_token != null) {
      //this is run on single login page domain inside an iframe on the tenancy domain to verify login CSRF token and send the login token through postMessage
      if (persistentStorage.get("loginTenancyUrl") != null) {
        if (persistentStorage.get("loginCSRFToken") != null && persistentStorage.get("loginToken") != null && persistentStorage.get("loginCSRFToken") === this.$route.query.login_csrf_token) {
            window.parent.postMessage({
            message: "LoginTokenCSRFValidation",
            data: {
                token: persistentStorage.get("loginToken")
            }
            }, persistentStorage.get("loginTenancyUrl"));
        }
        else {
            window.parent.postMessage({
            message: "LoginTokenCSRFValidation"
            }, persistentStorage.get("loginTenancyUrl"));
        }
      }
      persistentStorage.set("loginToken", null);
      persistentStorage.set("loginCSRFToken", null);
      persistentStorage.set("loginTenancyUrl", null);
    } else if (this.$route.query.login_verification_url) {
      //this is run on the tenancy domain when logging in with a token (coming from single login page). We open the the single login page in an iframe to check login CSRF and to get the login token.
      var play_dashboard_hostname = this.$root.getPlayDashboardHostName();
      var login_verification_url = this.$route.query.login_verification_url;
      if (this.validRedirect(login_verification_url)) {

        //register iframe listener to receive message from iframe when CSRF token has been verified and to obtain login token
        window.addEventListener("message", (event) => {
          var validation_message = event.data;
          if (event.origin === utils.originOfURL(login_verification_url) && validation_message.message != null && validation_message.message === "LoginTokenCSRFValidation") {
            this.tokenLoginCSRFLink = '';
            if (validation_message.data.token != null) {
              authHandler.loginWithToken(validation_message.data.token, play_dashboard_hostname, response => {
                if (response.status === 'success') {
                  this.loginSuccess(response);
                } else {
                  this.tokenLoginFailure(response);
                }
              });
            }
            else {
              this.error = this.$t('login_failed');
            }
          }
        }, false);

        //open iframe to check CSRF token and obtain login token
        this.tokenLoginCSRFLink = login_verification_url;
      } else {
        this.error = this.$t('login_failed');
      }
    } else if (this.$route.query.login_token != null) {
      //Microsoft tenancy login through tenancy login page, coming from single login page in between
      //OR coming through LTI or SAML login
      dashboardUserService.validateLoginTokenCredentials(this.$route.query.login_token).then((validation_response) => {
        if (validation_response.authUserId == null) {
          this.error = this.$t('login_failed');
          return;
        }

        let csrf_verification = Promise.resolve(true);
        if (validation_response.requiresCSRFToken === null || validation_response.requiresCSRFToken === true) {
          if (persistentStorage.enabled()) {
            if (this.$route.query.csrf_token == null || persistentStorage.get("loginCSRFToken") !== this.$route.query.csrf_token) {
              this.$log.warn("Could not login, csrf token does not match local storage csrf token: " + persistentStorage.get("loginCSRFToken") + ", csrf token in query param " + this.$route.query.login_csrf_token);
              this.error = this.$t('login_failed');
              return;
            }
          }
          else {
            //In LTI 1.3 when iframed we sometimes don't have access to any persistent storage we can't do login CSRF checks
            //in this case fallback
            csrf_verification = this.$root.confirmPromise(this.$t('login_with_user_confirm', { email: validation_response.email }));
          }
        }

        csrf_verification.then(() => {
          persistentStorage.set("loginCSRFToken", null);
          var play_dashboard_hostname = this.$root.getPlayDashboardHostName();
          authHandler.loginWithToken(this.$route.query.login_token, play_dashboard_hostname, response => {
            if (response.status === 'success') {
              if (validation_response.redirectURL != null && validation_response.redirectURL.startsWith("/project/")) {
                //specifically support for redirecting directly into a meeting (this is LTI)
                var project_id = validation_response.redirectURL.substring("/project/".length, validation_response.redirectURL.length);
                project_id = project_id.substring(0, project_id.indexOf("/"));
                this.$router.push({ name: 'MeetingDefault', params: { meetingId: project_id } });
                /*var properties = {
                  action:           "openProject",
                  projectId:        project_id,
                  tutorialStarted:  "false",
                  username:         ""
                };
                let url = this.$root.getPlayDashboardUrl();
                dashboardUserSessionService.getTransferSessionToken(properties).then(response => {
                  window.location.href = url+"/ssotransfer/"+response.transferToken;
                });*/
              }
              else {
                this.loginSuccess(response);
              }
            } else {
              this.tokenLoginFailure(response);
            }
          });
        }).catch(failure => {
          this.error = this.$t('login_failed');
        });
      }, (failure) => {
        this.error = this.$t('login_failed');
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
iframe {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/login/TokenLogin.vue